// External libraries
import { css } from '@emotion/core';

// Internal modules
import {
  DEFAULT_BORDER_COLOR,
  DISABLED_BACKGROUND_COLOR,
  HEADER_COLOR,
  WARNING_COLOR,
  WARNING_MESSAGE_BACKGROUND_COLOR,
} from '@/styles';

const errorFieldStyleOverrides = css`
  background-color: ${WARNING_MESSAGE_BACKGROUND_COLOR};
  border: 1px solid ${WARNING_COLOR};
  border-radius: 4px;
  margin-bottom: 16px;
  padding: 13px;

  p {
    color: ${HEADER_COLOR};
    font-weight: 400;
  }
`;

const getRadioBoxShadow = (displayError, disabled) => {
  if (disabled) {
    return `inset 0 0 0 100px ${DISABLED_BACKGROUND_COLOR}`;
  }
  return `inset 0 0 0 1px ${
    displayError ? WARNING_COLOR : DEFAULT_BORDER_COLOR
  }`;
};

const getRadioButtonStyleOverrides = (displayError, disabled = false) => ({
  containerStyleOverrides: css`
    margin-bottom: 12px;
  `,
  labelStyleOverrides: css`
    cursor: ${disabled ? 'default' : 'pointer'};
    font-weight: 400;

    &::before {
      box-shadow: ${getRadioBoxShadow(displayError, disabled)};
    }
  `,
});

export { errorFieldStyleOverrides, getRadioButtonStyleOverrides };
